import { useEffect } from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useLocation,
} from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/index.css";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import Intro from "@/pages/Intro";
import Quiz from "@/pages/Quiz";
import Result from "@/pages/Result";

function SmoothScroll() {
    const { pathname } = useLocation();

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export default function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <SmoothScroll />
                <div className="grain" aria-hidden="true" />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/intro" element={<Intro />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route path="/r/:patternSlug" element={<Result />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Toaster theme="dark" position="top-center" />
            </BrowserRouter>
        </ErrorBoundary>
    );
}
